export default "__VITE_ASSET__B6aEw_ou__"